
  function filter_pagi(){
     var endlessScroll = new Ajaxinate({
    container: '#product-grid',
    pagination: '#AjaxinatePagination',
    method: 'scroll',
    offset: 1000
  });
  } 

  $(document).on('change','select.facet-filters__sort.select__select', function(){
    console.log('iff')
    setTimeout(function(){
       filter_pagi();
      console.log('elsee')
    }, 2000)
  })
  $(document).on('change','.facets__item', function(){
    console.log('iff')
    setTimeout(function(){
       filter_pagi();
      console.log('elsee')
    }, 2000)
  })

   $(document).on('change','select#SortBy-mobile', function(){
    console.log('iff')
    setTimeout(function(){
       filter_pagi();
      console.log('elsee')
    }, 2000)
  })
  $(document).on('click','.mobile-facets__label', function(){
    console.log('iff')
    setTimeout(function(){
       filter_pagi();
      console.log('elsee')
    }, 2000)
  })


$(document).ready(function() {
    $('.moreless-button').click(function() {
        var $this = $(this);
        var $moreText = $('.more-text');
        var initialHeight = 370; // Initial height in pixels
        var threshold = 10; // Threshold to handle slight differences in height

        // Check if the height is close to the initial height
        if ($moreText.height() <= initialHeight + threshold) {
            var autoHeight = $moreText.css('height', 'auto').height();
            $moreText.height(initialHeight); // Reset to initial height before animation
            $moreText.stop().animate({ height: autoHeight }, 500, function() {
                $moreText.css('height', 'auto'); // After animation, set to auto
            });
            $this.text("Read Less");
        } else {
            $moreText.stop().animate({ height: initialHeight }, 500);
            $this.text("Read More");
        }
    });
});


$('.head').click(function(e) {
    e.preventDefault();
if ($(window).width() < 600){
    var currentIsActive = $(this).hasClass('is-active');
    $(this).parent('.accordion').find('> *').removeClass('is-active');
    if(currentIsActive != 1) {
        $(this).addClass('is-active');
        $(this).next('.content').addClass('is-active');
    }
}
});

$(document).on('click','.quick-add__submit', function(e){
  window.upcartOpenCart();
  setTimeout(function(){
    window.upcartRefreshCart();
  },1500)

  setTimeout(function(){
  $.ajax({
        type: 'GET',
        url: '/cart.js',
        cache: false,
        dataType: 'json',
        success: function(cart) {
          console.log('cart',cart)
          $('.cart-count-bubble span').text(cart.item_count);
        }
    });
    }, 2000)
  
}) 